import React from "react";

const Content = ({
  title,
  image,
  index,
  backgroundClass,
  btnColor,
  content,
}) => {
  return (
    <div
      className={`w-full  cursor-pointer h-[900px] md:h-screen ${backgroundClass} flex flex-col md:flex-row items-center justify-center`}
    >
      <div
        className={`w-[90%] md:w-1/2 h-[350px] md:h-full flex justify-center md:justify-center items-center  ${
          index % 2 === 0 ? "md:order-1" : "md:order-2"
        } `}
      >
        <img
          src={image}
          className="h-full object-cover w-4/5  md:w-[80%]  lg:h-[400px] lg:w-[400px] md:h-96 pt-10 pb-5 md:py-0"
          alt=""
        />
      </div>
      <div
        className={`w-[90%]  my-10 md:my-0 md:w-1/2 h-full  flex flex-col  justify-center md:justify-center items-center 
        ${
          index % 2 === 0
            ? "md:order-2 md:pr-10"
            : "md:order-1 md:px-5 md:pl-10 "
        } 
        `}
      >
        <div className="md:max-w-[550px]  mx-auto w-full  ">
          <h1 className="text-2xl tracking-wide leading-8 mb-5 ">{title}</h1>
          <p className="text-xl tracking-wide leading-8 mb-5  ">{content}</p>
          <a href="https://skinefits.pitiplus.app/">
            <button
              className={`${btnColor} mt-4 font-extralight leading-8 tracking-widest text-white text-sm px-10 py-2 rounded-sm shadow-sm hover:scale-105 transition`}
            >
              Shop Now
            </button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Content;
